import { render } from "./Navbar19View.vue?vue&type=template&id=12426ed6"
const script = {}

import exportComponent from "E:\\2023-1\\sukun\\Sukun-Psikotes-FE-Peserta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__